import { Box } from '@mui/material'
import Header from 'src/view/layout/Header'

const styles = {
  root: {
    color: 'inherit',
    fontFamily: `'Roboto', sans-serif`,
  },

  content: {
    //The content goes under the header because the header is MuiAppBar, which has position:'fixed'.
    //The header has height:'55px' so we need to move the content 55px down to align in below the header and not under it.
    //Add another 10px to a total of 65 fixels there is a 10px margin between the header and the content.

    //We set margins here instead of having a ContentWrapper on every page.
    margin: '10px',
    marginTop: '65px',
  },
}

function LayoutPublic(props) {
  return (
    <>
      <Box sx={styles.root}>
        <Header hideMenuIcon/>
        <Box sx={styles.content}>{props.children}</Box>
      </Box>
      {/* <Footer /> */}
    </>
  )
}

export default LayoutPublic
